import React, { useEffect, useState } from "react";
import _OrderRow from "./_OrderRow";
import { FaSearch } from "react-icons/fa";

function _Completed() {
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [completedOrder, setCompletedOrder] = useState([]);
  const [updateCompletedOrder, setUpdateCompletedOrder] = useState(false);

  // ✅ search state
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ keep track of selected orders
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  useEffect(() => {
    let intervalId;

    async function fetchOrderContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-completed-order`,
          { credentials: "include" }
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.completedOrder)) {
          setCompletedOrder(data.completedOrder);
          //console.log("data.completedOrder :", data.completedOrder);
        } else {
          console.error("Invalid response:", data);
          setCompletedOrder([]);
        }
      } catch (err) {
        console.error("Failed to fetch pending orders", err);
        setCompletedOrder([]);
      }
    }

    fetchOrderContent(); // run immediately once

    // ⏱️ set interval
    intervalId = setInterval(fetchOrderContent, 10000);

    // 🧹 cleanup when component unmounts or dependency changes
    return () => clearInterval(intervalId);
  }, [updateCompletedOrder]);

  // ✅ filter orders based on search term
  const filteredOrders = completedOrder.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    const displayStatus =
      order.COI_Status === "Paid" ? "FP Paid" : order.COI_Status || "";

    return (
      order.PD_Name?.toLowerCase().includes(keyword) ||
      order.PO_Number?.toLowerCase().includes(keyword) ||
      `${order.CP_Firstname} ${order.CP_Lastname}`
        .toLowerCase()
        .includes(keyword) ||
      displayStatus.toLowerCase().includes(keyword)
    );
  });

  // ✅ handle toggle of one row
  const handleRowSelect = (id) => {
    setSelectedOrders((prev) =>
      prev.includes(id) ? prev.filter((oid) => oid !== id) : [...prev, id]
    );
  };

  // ✅ handle toggle all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(filteredOrders.map((o) => o.COI_ID));
    } else {
      setSelectedOrders([]);
    }
  };
  // ✅ check if all are selected
  const allSelected =
    filteredOrders.length > 0 &&
    filteredOrders.every((o) => selectedOrders.includes(o.COI_ID));

  return (
    <main className="ad-order-panel-container">
      <div className="order-panel-header">
        <div className="order-panel-title-wrapper">
          <span>COMPLETED ORDER</span>
        </div>
        <div className="order-panel-actions-wrapper">
          {/* ✅ Only show button when there are selected orders 
          {selectedOrders.length > 0 && (
            <button disabled>
              VIEW ORDER HISTORY ({selectedOrders.length})
            </button>
          )}*/}
          {selectedOrders.length > 0 && (
            <button disabled>READY TO SHIP ({selectedOrders.length})</button>
          )}

          <div className="order-search-bar">
            <input
              type="text"
              placeholder="Keyword..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span>
              <FaSearch />
            </span>
          </div>
        </div>
      </div>

      <div className="order-panel-table-wrapper">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={handleSelectAll}
                />
              </th>
              <th></th>
              <th>PRODUCT NAME</th>
              <th>CUSTOMER NAME</th>
              <th>ORDER TYPE</th>
              <th>DATE PURCHASE</th>
              <th>TOTAL AMOUNT</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => (
                <_OrderRow
                  key={order.COI_ID}
                  order={order}
                  menuOpenId={menuOpenId}
                  setMenuOpenId={setMenuOpenId}
                  isSelected={selectedOrders.includes(order.COI_ID)}
                  onSelect={() => handleRowSelect(order.COI_ID)}
                  expandedId={expandedId}
                  setExpandedId={setExpandedId}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan="10"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </main>
  );
}

export default _Completed;
